import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PlusCircle, Pencil, Trash2, Eye, EyeOff, Search } from "lucide-react";
import { api } from "../../api";
import { Input } from "../../components/ui/input";

export default function PagesList() {
  const [pages, setPages] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try { const { data } = await api.get("/admin/pages"); setPages(data); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("Delete this page?")) return;
    await api.delete(`/admin/pages/${id}`);
    load();
  };

  const filtered = pages.filter((p) => p.title.toLowerCase().includes(q.toLowerCase()) || p.slug.includes(q.toLowerCase()));

  return (
    <div>
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 className="text-2xl md:text-3xl font-bold">Custom Pages</h1>
          <p className="text-slate-400 text-sm mt-1">Create new pages with full SEO control. Pages render at <code className="text-amber-300">/p/your-slug</code>.</p>
        </div>
        <Link to="/admin/pages/new" className="btn-gold inline-flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm"><PlusCircle className="w-4 h-4" /> New Page</Link>
      </div>
      <div className="mt-5 relative max-w-md">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search pages..." className="pl-9 bg-[#0c1530] border-white/10 text-white placeholder:text-slate-500 focus-visible:ring-amber-500" />
      </div>

      <div className="mt-5 card-dark overflow-hidden">
        {loading ? (
          <div className="p-10 text-center text-slate-400">Loading...</div>
        ) : filtered.length === 0 ? (
          <div className="p-10 text-center text-slate-400">No pages yet. <Link to="/admin/pages/new" className="text-amber-400">Create your first page</Link></div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-white/5 text-slate-300">
              <tr>
                <th className="text-left px-4 py-3">Title</th>
                <th className="text-left px-4 py-3 hidden md:table-cell">URL</th>
                <th className="text-left px-4 py-3">Status</th>
                <th className="text-right px-4 py-3">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-white/5">
              {filtered.map((p) => (
                <tr key={p.id} className="hover:bg-white/[0.02]">
                  <td className="px-4 py-3 font-semibold text-white">{p.title}</td>
                  <td className="px-4 py-3 text-slate-400 hidden md:table-cell font-mono text-xs">/p/{p.slug}</td>
                  <td className="px-4 py-3">
                    {p.published ? <span className="inline-flex items-center gap-1 text-emerald-300 text-xs"><Eye className="w-3.5 h-3.5" /> Published</span> : <span className="inline-flex items-center gap-1 text-slate-400 text-xs"><EyeOff className="w-3.5 h-3.5" /> Draft</span>}
                  </td>
                  <td className="px-4 py-3 text-right">
                    <div className="inline-flex items-center gap-2">
                      <Link to={`/admin/pages/${p.id}`} className="text-amber-400 hover:text-amber-300" title="Edit"><Pencil className="w-4 h-4" /></Link>
                      <button onClick={() => remove(p.id)} className="text-rose-300 hover:text-rose-200" title="Delete"><Trash2 className="w-4 h-4" /></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
